<script lang="ts" setup>
const { loggedIn, user } = useUserSession();

const data = computed(() => {
  if (isBellaSicilia(loggedIn.value, user.value?.storeId)) {
    return {
      src: "/bella-sicilia/logo/logo-text.svg",
      alt: "Bella Sicilia Logo",
      title: "Bella Sicilia",
    };
  }

  return {
    src: "/spuntini/logo/logo-text.svg",
    alt: "Spuntini Logo",
    title: "Spuntini",
  };
});
</script>

<template>
  <NuxtLinkLocale to="/" class="focus-visible:outline-none">
    <NuxtImg :src="data.src" :alt="data.alt" :title="data.title" class="size-full object-contain" />
  </NuxtLinkLocale>
</template>

<style scoped>

</style>
